import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';

function getColspan(row, colums, index) {
  let colspan = 0;
  for (let i = index + 1; i < colums.length; i++) {
    if (i > colums.length - 1) {
      break;
    }
    if (row[colums[i].field] === undefined) {
      colspan = colspan ? colspan + 1 : 2;
    } else {
      break;
    }
  }
  return colspan;
}
const ItemListTable = ({
  rows = [],
  columns = [],
  sx,
  rowLink,
  linkTarget = '_self',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Box, _extends({
    sx: {
      maxWidth: '100%',
      overflow: 'auto',
      ...sx
    }
  }, props), props.isLoading && /*#__PURE__*/React.createElement(LinearProgress, null), !props.isLoading && /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "simple table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, columns.map(column => /*#__PURE__*/React.createElement(TableCell, _extends({
    key: column.field
  }, column), column.headerName || column.field)))), /*#__PURE__*/React.createElement(TableBody, null, rows.map((row, i) => /*#__PURE__*/React.createElement(TableRow, {
    hover: true,
    key: row.name,
    sx: {
      '&:last-child td, &:last-child th': {
        border: 0
      }
    },
    onClick: async () => props.onRowClick && (await props.onRowClick(row))
  }, columns.map((column, j) => row[column.field] !== undefined && /*#__PURE__*/React.createElement(TableCell, {
    key: column.field,
    colSpan: getColspan(row, columns, j),
    sx: {
      py: 0,
      px: 0
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: rowLink == null ? void 0 : rowLink(row),
    key: 'link-' + i + '-' + j,
    target: linkTarget,
    underline: "none",
    sx: {
      width: '100%',
      display: 'block',
      height: '100%',
      py: 2,
      px: 2
    }
  }, row[column.field])))))))));
};

export { ItemListTable, ItemListTable as default };
